import {
    OBTENER_USUARIOS,
    OBTENER_USUARIOS_ROL,
    AGREGAR_USUARIO,
    ELIMINAR_USUARIO,
    ACTUALIZAR_USUARIO,
    USUARIO_ERROR,
    USUARIO_OK,
    USUARIO_ACTUAL,
    OBTENER_USUARIO,
    OBTENER_TABLA_USUARIO,
    OBTENER_ESTADO_SOPORTE
} from 'types/context';

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
    switch (action.type) {
        case OBTENER_USUARIOS:
            return {
                ...state,
                usuarios: action.payload
            }
        case OBTENER_TABLA_USUARIO:
            return { 
                ... state,
                usuarios:action.payload
            }
        case OBTENER_USUARIOS_ROL:
            return {
                ...state,
                usuarios: action.payload
            }
        case USUARIO_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case USUARIO_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_USUARIO:
            return {
                ...state,
                usuarios: [...state.usuarios, action.payload],
                formulario: false,
                errorformulario: false
            }
        case USUARIO_ACTUAL:
            return {
                ...state,
                usuario: state.usuarios.find(disp => disp._id === action.payload)
            }
        case ELIMINAR_USUARIO:
            return {
                ...state,
                usuarios: state.usuarios.filter(disp => disp._id !== action.payload),
                usuario: null
            }
        case ACTUALIZAR_USUARIO:
            return {
                ...state,
                usuarios: state.usuarios.map(disp => disp._id === action.payload._id ? action.payload : disp),
                usuario: action.payload
            }
        case OBTENER_USUARIO:
            return {
                ...state,
                usuario: action.payload
            }
        case OBTENER_ESTADO_SOPORTE:
            return{
                ...state,
                soporteActivo: action.payload
            }
        default:
            return state;
    }
}